import { makeMeSticky } from '@app/utils/domHelpers'

export default () => {
  makeMeSticky('[data-behaviour="export-add-list"]', 70)
}
